namespace Portico.Services {
	import psga = apigateway.client;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface ITenantService {
  //      get: () => angular.IPromise<pme.Tenant[]>;
		//getById: (id: number) => angular.IPromise<pme.Tenant>;
    }

    @Service('app', 'tenantService')
	@Inject('$q', 'ProgramV2Api')
    export class TenantService implements ITenantService {
        constructor(
			private $q: angular.IQService,
			private programV2Api: psga.ProgramV2Api
        ) { }

		//get(): angular.IPromise<pme.Tenant[]> {
		//	const request: DeepPartial<psgm.ProgramTenantSearchPostRequestV2> = {};

		//	return this.programV2Api.tenantSearch(request).then((response) => {
		//		const tenants: pme.Tenant[] = [];

  //              for (const tenant of response) {
		//			tenants.push(new pme.Tenant(tenant));
  //              }

  //              return tenants;
  //          });
  //      }

		//getById(id: number): angular.IPromise<pme.Tenant> {
		//	const request: DeepPartial<psgm.ProgramTenantSearchPostRequestV2> = {
		//		tenantId: id
		//	};

		//	return this.programV2Api.tenantSearch(request).then((response) => {
		//		return new pme.Tenant(response[0]);
  //          });
  //      }
    }
}